import { SIZE_FULL } from '@/lib/gridElements/size';

import { TiktokWidget } from '@/components/pages/analyze/widget/TiktokWidget';

export const mostEngagingVideosConfig = {
    title: 'chart.tiktok.widget_most_engaging_videos',
    id: 'widget_most_engaging_posts',
    size: SIZE_FULL,
    sortFields: ['engagement_on_views', 'favorites'],
    type: 'widget',
    element: TiktokWidget
};
